import { createContext, useContext } from "react";

export type ChineseCharacterMode = "default" | "japanese";

export interface ReadingSettingsContextValue {
  chineseCharacterMode: ChineseCharacterMode;
  setChineseCharacterMode: (mode: ChineseCharacterMode) => void;
}

export const ReadingSettingsContext =
  createContext<ReadingSettingsContextValue>({
    chineseCharacterMode: "default",
    setChineseCharacterMode: () => {},
  });

export const useReadingSettings = () => useContext(ReadingSettingsContext);
